<template>
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M22.6641 11.3389C23.7686 11.3389 24.6641 10.4434 24.6641 9.33887C24.6641 8.2343 23.7686 7.33887 22.6641 7.33887C21.5595 7.33887 20.6641 8.2343 20.6641 9.33887C20.6641 10.4434 21.5595 11.3389 22.6641 11.3389Z"
            fill="white" />
        <path
            d="M21.3333 4.00684C25.0133 4.00684 28 6.9935 28 10.6735V21.3402C28 25.0202 25.0133 28.0068 21.3333 28.0068H10.6667C6.98667 28.0068 4 25.0202 4 21.3402V10.6735C4 6.9935 6.98667 4.00684 10.6667 4.00684H16H21.3333Z"
            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        <path
            d="M15.9974 10.6748C18.9441 10.6748 21.3307 13.0615 21.3307 16.0081C21.3307 18.9548 18.9441 21.3415 15.9974 21.3415C13.0507 21.3415 10.6641 18.9548 10.6641 16.0081C10.6641 13.0615 13.0507 10.6748 15.9974 10.6748Z"
            stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
</template>